import React, { useEffect } from "react";
import "./Account.css";
import ProfileCard from "./ProfileCard/ProfileCard";
import WalletActions from "./WalletActions/WalletActions";
import MenuGrid from "./MenuGrid/MenuGrid";
import ServiceCenter from "./ServiceCenter/ServiceCenter";
import BottomNav from "./BottomNav/BottomNav";
import Tab_list from "../Common/Common_Component/Tab_list/Tab_list";
import { useDispatch, useSelector } from "react-redux";
import { GETAuthLogin } from "../../features/auth/Slice";
import { IDS } from "../../utils/IDS";
import { formatAmount, formatDate, formatNotifDate } from "../../utils/common";

function Account() {

  const dispatch = useDispatch()
  const user = useSelector((state => state.auth));

  useEffect(() => { dispatch(GETAuthLogin()) }, [dispatch]);

  const tabListData = [
    {
      type: "link",
      name: "Notification",
      image: "/assets/images/icons/envolope.png",
      link: "/notifications",
    },
    {
      type: "link",
      name: "Gifts",
      image: "/assets/images/icons/gift.png",
      link: "/gift",
    },
    {
      type: "link",
      name: "Game Statistics",
      image: "/assets/images/icons/Graph.png",
      link: "/game-statistics",
    },
    {
      type: "text",
      name: "Language",
      image: "/assets/images/icons/web.png",
      value: "English",
    },
    {
      type: "copy",
      name: "Invitaion Code",
      image: "/assets/images/icons/invitation_code.png",
      value: user?.data?.refer_code,
    },
  ];
  return (
    <>
      <section className="Account">
        <div className="account-container">
            <ProfileCard
              name={user?.data?.name || ""}
              image={IDS.IMG_URL + user?.data?.profile_pic}
              user_uid={user?.data?.user_uid || ""}
              last_login={formatNotifDate(user?.data?.last_login) || ""}
              balance={formatAmount(user?.data?.Wallet?.amount) || ""}
            />
          <div className="container">
            <MenuGrid />
            <Tab_list listItems={tabListData} />
            <ServiceCenter />
            <BottomNav />

          </div>
        </div>
      </section>
    </>
  );
}

export default Account;
